import {
  DashboardOutlined,
  UploadOutlined,
  FileImageOutlined,
} from "@ant-design/icons";

export const BASE_URL =
 "https://api.yogarefer.com/api" || process.env.REACT_APP_BASE_URL;
//"http://localhost:5001/api" || process.env.REACT_APP_BASE_URL;

export const adminMenu = [
  {
    key: "admin-dashboard",
    icon: <DashboardOutlined />,
    label: "Dashboard",
    path: "/dashboard",
  },

  {
    key: "all-users",
    icon: <UploadOutlined />,
    label: "Users",
    children: [
      { key: "users", label: "All Users", path: "/all-users" },
      { key: "add-user", label: "Add User", path: "/add-user" },
    ],
  },

  {
    key: "asana-upload",
    icon: <UploadOutlined />,
    label: "Asana Upload",
    children: [
      { key: "asanas", label: "All Asanas", path: "/all-asana" },
      { key: "create-asana", label: "Add Asana", path: "/asana-upload" },
    ],
  },

  {
    key: "Pages",
    icon: <UploadOutlined />,
    label: "Pages",
    children: [
      { key: "allpages", label: "Add Pages", path: "/allpages" },
      {
        key: "view-all-pages",
        label: "View All Pages",
        path: "/view-allpages",
      },

      {
        key: "how-to-make-variations",
        label: "How to Make Variations",
        children: [
          {
            key: "make-variations",
            label: "Make Variations",
            path: "/make-variations",
          },
          {
            key: "all-make-variations",
            label: "View Make Variations",
            path: "/all-make-variations",
          },
        ],
      },

      { key: "user-asana", label: "User Asanas", path: "/user-asana-approve" },
    ],
  },

  {
    key: "variation-poses",
    icon: <UploadOutlined />,
    label: "Variation Poses",
    children: [
      {
        key: "var-approval",
        label: "Variation Approval",
        path: "/var-approval",
      },
      {
        key: "media-link",
        label: "Media Link Approval",
        path: "/media-link",
      },
    ],
  },

  {
    key: "global-images",
    icon: <DashboardOutlined />,
    label: "Global Images",
    path: "/overall-images",
  },
];

export const userMenu = [
  {
    key: "upload-variation",
    icon: <UploadOutlined />,
    label: "Upload Variation",
    path: "/user-page",
  },
  {
    key: "my-variation",
    icon: <FileImageOutlined />,
    label: "My Variations",
    path: "/my-variation",
  },
  {
    key: "User-asana-upload",
    icon: <FileImageOutlined />,
    label: "My Asanas",
    path: "/user-asana-upload",
  },
];
